import { SITE_URL } from '@/api/config'
import $ from 'jquery'
export default {
	name: 'globaloutlook',
	created() {
		this.setHeightIframe()
	},
	data: function() {
		return {
			url: '',
			heightiframe: 570,
			globalmapdisplay: ''

		}
	},
	mounted: function (){
		var windowSize = $( window ).width()
		var windowSizeheight = $( window ).height()
		var windowSizeheightex =  windowSizeheight - 60;
		var windowSizeheighttheam =  windowSizeheight - 20;
		$('#inlineFrameExample').css({"width": "100%", "height": windowSizeheightex+"px"});
		$('.draktheme #inlineFrameExample').css({"width": "100%", "height": windowSizeheighttheam+"px"});
		$('.lightheme #inlineFrameExample').css({"width": "100%", "height": windowSizeheighttheam+"px"});
	},
	methods: {
		setHeightIframe() {
			// do operations
			this.url = this.iframeurl()
		},
		iframeurl() {
			var iframurl = SITE_URL + 'research/dashboard/global-outlook/'
			if (this.$store.state.appsetting.panaray) {
				iframurl =
					iframurl +
					'?e=' +
					this.$store.state.appsetting.encemail +
					'&t=' +
					this.$store.state.appsetting.theme
			}
			return iframurl
		}
	},
	computed: {}
}



// WEBPACK FOOTER //
// ./src/assets/js/globaloutlook.js